// Asal: Produktseite – Galerie, Größenwahl, Menge, In den Warenkorb (öffnet den Impulse-Drawer),
// mitlaufende Kaufleiste, nächster Abholtermin aus dem Hub, Beschreibung als Akkordeons. Ohne Bibliotheken.
(() => {
  const root = document.querySelector('[data-asal-pdp]');
  if (!root) return;
  const $ = s => root.querySelector(s);
  const $$ = s => [...root.querySelectorAll(s)];

  // Galerie
  const track = $('[data-asal-track]');
  const thumbs = $$('.asal-pdp__thumb');
  const markThumb = i => thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
  thumbs.forEach(t => t.addEventListener('click', () => {
    const i = Number(t.dataset.index);
    track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    markThumb(i);
  }));
  if (track) track.addEventListener('scroll', () => markThumb(Math.round(track.scrollLeft / track.clientWidth)), { passive: true });

  // Größenwahl
  const input = $('[data-asal-variant-input]');
  const atc = $('[data-asal-atc]');
  const stickyBtn = root.querySelector('[data-asal-sticky-atc]');
  root.addEventListener('change', e => {
    const r = e.target.closest('.asal-variant input');
    if (!r) return;
    input.value = r.value;
    $('[data-asal-price]').textContent = r.dataset.price;
    $('[data-asal-unit]').textContent = r.dataset.unit;
    $('[data-asal-compare]').textContent = r.dataset.compare;
    root.querySelector('[data-asal-sticky-price]').textContent = r.dataset.price;
    const sv = root.querySelector('[data-asal-sticky-variant]');
    if (sv) sv.textContent = r.dataset.title;
    const url = new URL(location.href);
    url.searchParams.set('variant', r.value);
    history.replaceState({}, '', url);
  });

  // Menge
  root.addEventListener('click', e => {
    const b = e.target.closest('[data-asal-qty]');
    if (!b) return;
    const q = b.parentElement.querySelector('input');
    q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.asalQty));
  });

  // In den Warenkorb per AJAX, danach Impulse-Drawer öffnen
  const form = $('[data-asal-form]');
  const err = $('[data-asal-error]');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    err.hidden = true;
    atc.classList.add('is-loading');
    atc.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Das hat nicht geklappt.');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: atc } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (ex) {
      err.textContent = ex.message;
      err.hidden = false;
    } finally {
      atc.classList.remove('is-loading');
      atc.disabled = false;
    }
  });
  if (stickyBtn) stickyBtn.addEventListener('click', () => form.requestSubmit());

  // Mitlaufende Kaufleiste, sobald der Kaufen-Knopf aus dem Bild ist
  const sticky = root.querySelector('[data-asal-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(atc);
  }

  // Beschreibung: Zwischenüberschriften werden zu Akkordeons
  const desc = root.querySelector('[data-asal-desc] .asal-acc__intro');
  if (desc) {
    const nodes = [...desc.childNodes];
    const isHead = n => n.nodeType === 1 && /^(H[2-6])$/.test(n.tagName) && n.textContent.trim();
    if (nodes.some(isHead)) {
      const wrap = desc.parentElement;
      let current = null;
      const items = [];
      nodes.forEach(n => {
        if (isHead(n)) {
          const d = document.createElement('details');
          d.className = 'asal-acc__item';
          const s = document.createElement('summary');
          s.textContent = n.textContent.trim();
          const body = document.createElement('div');
          body.className = 'rte';
          d.append(s, body);
          items.push(d);
          current = body;
          n.remove();
        } else if (current) {
          current.append(n);
        }
      });
      // Leere Absätze am Anfang entfernen, ersten Bereich geöffnet lassen
      [...desc.children].forEach(c => { if (!c.textContent.trim() && !c.querySelector('img')) c.remove(); });
      if (items[0]) items[0].open = !desc.textContent.trim();
      wrap.append(...items);
    }
  }

  // Nächster Abholtermin + Terminliste aus dem Orangen Hub (Ort und Adresse kommen ebenfalls aus dem Hub)
  const next = $('[data-asal-next]');
  const datesBox = root.querySelector('[data-asal-pdp-dates]');
  const fmt = (d, o) => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', o);
  // Unmissverständlich: Wochentag ausgeschrieben, Datum mit Jahr (Samstag, 28.11.2026), Uhrzeit vierstellig.
  const long = d => fmt(d, { weekday: 'long' }) + ', ' + fmt(d, { day: '2-digit', month: '2-digit', year: 'numeric' });
  const dl = x => { const [dd, t] = x.split('T'); return long(dd) + ', ' + t + ' Uhr'; };
  const bold = t => { const b = document.createElement('strong'); b.textContent = t; return b; };
  const asalRun = () => (window.AsalPlace ? window.AsalPlace.load() : Promise.reject(new Error('AsalPlace fehlt'))).then(({ days = [] }) => {
    if (!days.length) { if (next) next.hidden = true; if (datesBox) datesBox.hidden = true; return; }
    const d = days.find(x => x.bookable && x.slots.some(s => s.available)) || days[0];
    const where = d.place ? d.place.name : (d.location || '');
    if (next) {
      const parts = ['Nächste Abholung: ', bold(long(d.date)), where ? ' in ' + where : ''];
      if (d.bookable && d.deadline) parts.push(document.createElement('br'), 'Bestellen bis ', bold(dl(d.deadline)));
      else if (!d.bookable) parts.push(document.createElement('br'), 'Buchung startet bald');
      next.querySelector('span').replaceChildren(...parts);
      next.hidden = false;
    }
    if (datesBox) {
      const list = datesBox.querySelector('[data-asal-pdp-dates-list]');
      list.replaceChildren(...days.slice(0, 6).map(x => {
        const free = x.slots.reduce((n, s) => n + s.free, 0);
        const row = document.createElement('div');
        row.className = 'asal-pdp-dates__row';
        const cal = document.createElement('span');
        cal.className = 'asal-pdp-dates__cal';
        cal.innerHTML = '<small></small><b></b>';
        cal.querySelector('small').textContent = fmt(x.date, { month: 'short' }).replace('.', '');
        cal.querySelector('b').textContent = fmt(x.date, { day: 'numeric' });
        const txt = document.createElement('span');
        txt.className = 'asal-pdp-dates__txt';
        const t1 = document.createElement('strong');
        t1.textContent = fmt(x.date, { weekday: 'long' }) + (x.place && new Set(days.map(y => y.place && y.place.id)).size > 1 ? ' · ' + x.place.name : '');
        const t2 = document.createElement('small');
        if (x.deadline) t2.replaceChildren('Bestellen bis ', bold(dl(x.deadline)));
        const st = document.createElement('em');
        st.className = 'asal-pdp-dates__state' + (!x.bookable ? ' is-soon' : free === 0 ? ' is-full' : free < 30 ? ' is-few' : '');
        st.textContent = !x.bookable ? 'bald buchbar' : free === 0 ? 'ausgebucht' : free + ' Plätze frei';
        // Status-Plakette in der Kopfzeile neben dem Wochentag, damit der Bestellschluss die volle Breite hat
        const head = document.createElement('span');
        head.className = 'asal-pdp-dates__head';
        head.append(t1, st);
        txt.append(head, t2);
        row.append(cal, txt);
        return row;
      }));
      const p = d.place;
      const card = datesBox.querySelector('[data-asal-pdp-place]');
      if (p && card) {
        const f = k => card.querySelector('[data-f="' + k + '"]');
        f('name').textContent = 'Abholort: ' + p.name;
        f('address').textContent = p.address || '';
        f('info').textContent = p.info || '';
        f('info').hidden = !p.info;
        f('map').href = p.map || 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(p.address || p.name);
        card.hidden = false;
      }
      datesBox.hidden = false;
    }
  }).catch(() => {});
  asalRun();
  document.addEventListener('asal:place', asalRun);

  // Wird oft zusammen gekauft: Hub-Daten stehen schon im HTML (data-asal-together-static); sonst erst ergänzende
  // Produkte (Search & Discovery), dann ähnliche nachladen. Plus legt direkt in den Warenkorb.
  const together = root.querySelector('[data-asal-together]');
  if (together) {
    const load = intent => fetch(together.dataset.url + '&intent=' + intent)
      .then(r => (r.ok ? r.text() : ''))
      .then(html => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-asal-together-list]'));
    const filled = l => l && l.children.length ? l : null;
    if (!together.hasAttribute('data-asal-together-static')) load('complementary').then(l => filled(l) || load('related')).then(l => {
      if (!filled(l)) return;
      together.querySelector('.asal-together__body').replaceChildren(l);
      together.hidden = false;
    }).catch(() => {});
    together.addEventListener('click', async e => {
      const b = e.target.closest('[data-asal-together-add]');
      if (!b || b.disabled) return;
      b.disabled = true;
      b.classList.add('is-loading');
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.asalTogetherAdd), quantity: 1 }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Nicht verfügbar');
        b.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: b } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      } catch (ex) {
        b.title = ex.message;
      } finally {
        b.classList.remove('is-loading');
        setTimeout(() => { b.disabled = false; b.classList.remove('is-added'); }, 2200);
      }
    });
  }
})();
